import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_list_item = _resolveComponent("v-list-item");
    const _component_v_autocomplete = _resolveComponent("v-autocomplete");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["searchFieldWrapper", {
                searchBarWrapperMobile: _ctx.isMobile,
                searchBarWrapperDesktop: !_ctx.isMobile,
                blueArea: _ctx.blueOrRed == 'blue',
                'd-none': !_ctx.isBlueOrRed,
            }])
    }, [
        _createVNode(_component_v_autocomplete, {
            enterkeyhint: "go",
            onKeydown: _withKeys(_ctx.search, ["enter"]),
            "no-data-text": "Bitte gebe einen Suchbegriff ein.",
            ref: "searchautocomplete",
            "auto-select-first": "",
            clearable: "",
            "no-filter": "",
            "item-title": "products_name",
            "item-value": "link",
            items: _ctx.itemsResponse,
            density: "compact",
            placeholder: _ctx.placeholderText,
            "onUpdate:search": _ctx.search,
            "onUpdate:modelValue": _ctx.search
        }, {
            item: _withCtx(({ props, item }) => {
                var _a, _b;
                return [
                    _createVNode(_component_v_list_item, _mergeProps({ class: "autoCompleteItems" }, props, {
                        "prepend-avatar": (_a = item === null || item === void 0 ? void 0 : item.raw) === null || _a === void 0 ? void 0 : _a.icon,
                        title: (_b = item === null || item === void 0 ? void 0 : item.raw) === null || _b === void 0 ? void 0 : _b.products_name
                    }), null, 16, ["prepend-avatar", "title"])
                ];
            }),
            _: 1
        }, 8, ["onKeydown", "items", "placeholder", "onUpdate:search", "onUpdate:modelValue"]),
        _hoisted_1
    ], 2));
}
